<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { onMount } from 'svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  let schoolCode: string;
  let schoolName: string = $state();

  let autoCompleteElement: AutoComplete = $state();

  onMount(() => {
    schoolName = alert?.props?.schoolName || '';
    const schoolInfo = alert?.props?.list?.find(
      (item: any) => item.label === alert?.props?.schoolName
    );
    schoolCode = schoolInfo?.code || '';
    autoCompleteElement?.setValue(schoolName);
  });

  const onClickSchoolName = (detail: CommonList | any): void => {
    schoolCode = detail.code;
    schoolName = detail.label;
    onevent?.({
      type: 'change-schoolname',
      data: [
        { key: alert.key, type: schoolName },
        { key: 'schoolCode', type: schoolCode }
      ]
    });
  };

  const onSchoolNameInputCleared = (): void => {
    if (!schoolName) return;
    schoolCode = '';
    schoolName = '';
    onevent?.({
      type: 'clear-schoolname',
      data: [{ key: alert.key }, { key: 'schoolCode' }]
    });
  };

  const onSchoolCreate = (detail: any): void => {
    schoolName = detail;
    schoolCode = '';
    onevent?.({
      type: 'create-schoolname',
      data: [{ key: alert.key, type: schoolName }, { key: 'schoolCode' }]
    });
  };
</script>

<AlertView
  type={ListAlertType.EducationSchoolNameChange}
  key={Label.ChangeTo}
  icon="icon-corner-down-right"
>
  {#snippet value()}
    <div class="school-name">
      <AutoComplete
        canCreate
        showCreateInfo
        bind:this={autoCompleteElement}
        name="schoolName"
        infoLabel="Click to add school"
        placeholder="Search or add school name"
        list={alert?.props?.list || []}
        value={schoolName}
        onclick={onClickSchoolName}
        oncreate={onSchoolCreate}
        oncleared={onSchoolNameInputCleared}
      />
    </div>
  {/snippet}
</AlertView>

<style>
  .school-name {
    width: 500px;
    padding: 4px 16px;
  }
</style>
